import React, { Component } from 'react';

import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsStatusChangeObjectBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">The status change object</div>
          <APIDocsTable
            title="Attributes"
            rows={[
              {
                description: 'A unique identifier for the status change.',
                heading: 'id',
                subheading: 'string',
              },
              {
                description:
                  'The comment attached to this status change. Only imageURLs and value fields are included.',
                heading: 'changeComment',
                subheading: 'Comment object',
              },
              {
                description: 'The user who changed the status.',
                heading: 'changer',
                subheading: 'User object',
              },
              {
                description: 'Time at which the status was changed, in ISO 8601 format.',
                heading: 'created',
                subheading: 'string',
              },
              {
                description: 'The post that had its status changed.',
                heading: 'post',
                subheading: 'Post object',
              },
              {
                description: 'The status the post was changed to.',
                heading: 'status',
                subheading: 'string',
              },
            ]}
          />
        </div>
        <div>
          <div className="text">Example status change object:</div>
          <Highlight lang="json">
            {`{
  "changeComment": {
    "imageURLs": [
      "https://canny.io/images/93fc5808937760b82c3dc00aa5cd86b8.png",
      "https://canny.io/images/316e5600645b81e4be287a52d506dbfd.jpg"
    ],
    "value": "This is the status change comment value"
  },
  "changer": {
    "id": "553c3ef8b8cdcd1501ba123a",
    "created": "2017-07-15T22:11:00.000Z",
    "email": "test@test.test",
    "isAdmin": false,
    "name": "Sally Doe",
    "url": "https://your-company.canny.io/admin/users/sally-doe",
    "userID": "1234"
  },
  "created": "2017-08-30T13:32:01.000Z",
  "id": "553c3ef8b8cdcd1501ba12bb",
  "post": {
    "id": "553c3ef8b8cdcd1501ba1238",
    "author": {
      "id": "553c3ef8b8cdcd1501ba123a",
      "created": "2017-07-15T22:11:00.000Z",
      "email": "test@test.test",
      "isAdmin": false,
      "name": "Sally Doe",
      "url": "https://your-company.canny.io/admin/users/sally-doe",
      "userID": "1234"
    },
    "board": {
      "created": "2017-07-10T11:22:00.000Z",
      "id": "553c3ef8b8cdcd1501ba1234",
      "name": "Feature Requests",
      "postCount": 123,
      "url": "https://your-company.canny.io/admin/board/feature-requests"
    },
    "category": {
      "id": "553c3ef8b8cdcd1501ba2234",
      "name": "Dashboard",
      "postCount": 42,
      "url": "https://your-company.canny.io/admin/board/feature-requests?category=dashboard"
    },
    "changeComment": {
      "value": "The status has changed!",
      "imageURLs": ["https://canny.io/images/93fc5808937760b82c3dc00aa5cd86b2.png"]
    },
    "clickup": {
      "linkedTasks": [{
        "id": "123",
        "linkID": "2334jdsai23234io22",
        "name": "Clickup issue",
        "postID": "553c3ef8b8cdcd1501ba1238",
        "status": "to do",
        "url": "https://app.clickup.com/t/123456"
      }]
    },
    "commentCount": 10,
    "created": "2017-08-22T13:32:00.000Z",
    "details": "Test post details",
    "eta": "February 2020",
    "imageURLs": [
      "https://canny.io/images/93fc5808937760b82c3dc00aa5cd86b8.png",
      "https://canny.io/images/316e5600645b81e4be287a52d506dbfd.jpg"
    ],
    "jira": {
      "linkedIssues": [{
        "id": "123",
        "key": "ID-123",
        "url": "https://your-company.atlassian.net/browse/ID-123"
      }]
    },
    "linear": {
      "linkedIssueIDs": ["ID-123", "ID-345"],
    },
    "mergeHistory":[{
      "created":"2018-06-17T22:42:37.167Z",
      "post": {
        "created":"2018-06-17T22:42:00.797Z",
        "details":"Awesome feature post details",
        "id": "553c3ef8b8cdcd1501ba6789",
        "imageURLs":[],
        "title":"Another awesome feature request"
      }
    }],
    "score": 72,
    "status": "in progress",
    "statusChangedAt": "2017-08-24T23:22:00.000Z",
    "tags": [{
      "id": "553c3ef8b8cdcd1501ba3234",
      "name": "iOS",
      "postCount": 15,
      "url": "https://your-company.canny.io/admin/board/feature-requests?tags=ios"
    }],
    "title": "An awesome feature request",
    "url": "https://your-company.canny.io/admin/board/feature-requests/p/an-awesome-feature-request"
  },
  "status": "in progress"
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
